import * as React from 'react';
import PropTypes from 'prop-types';

const SvgActionsGlobalNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M16 .175A15.825 15.825 0 1031.825 16 15.843 15.843 0 0016 .175zm13.74 19.247l-.873-1.639h-3.606l-2.15-4.04L25.632 9h2.678a13.945 13.945 0 011.43 10.423v-.001zM10.95 2.772a14.032 14.032 0 013.34-.833l-1.838 3.453h-1.5l-.003-2.62zm-1.65.743v3.527h4.145l2.77-5.206c.12 0 .234.013.352.018l3.051 5.736-4.763 2.53-2.69 5.055H8.881v3.887l.7 1.311-3.192-1.7-3.823-7.164A14.238 14.238 0 019.3 3.515zM1.825 16c.005-.69.061-1.378.167-2.059L5.164 19.9l6.658 3.538-1.537 2.881L12.03 29.6A14.192 14.192 0 011.825 16zm12.308 14.037l-1.979-3.719L13.391 24h5.01l2.464 1.3H23.2l1.138 2.133a13.816 13.816 0 01-10.206 2.6l.001.004zm11.505-3.672l-1.447-2.712H21.28l-2.465-1.3h-5.52l-1.119-.595-1.643-3.1v-1.833h2.624l2.92-5.484 5.776-3.066-3.3-6.208A14.172 14.172 0 0127.2 7.349h-2.559l-3.4 6.394 3.028 5.691h3.606l1.147 2.154a14.234 14.234 0 01-3.384 4.777z"
        fill=""
      />
    </svg>
  )
);
SvgActionsGlobalNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgActionsGlobalNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgActionsGlobalNormalMedium;
